import {cargoApiURL} from '@yandex-delivery/client-core/api/corp'
import {fetch} from '@yandex-delivery/core/utils/network'
import {addQuery, delay} from '@yandex-delivery/utils'

import {DELAY_TIMEOUT_MS} from 'src/shared/consts'
import type {
  MakeUrlApi,
  OptimizeRouteResultRequest,
  OptimizeRouteResultResponse,
  OptimizeRouteStartRequest,
  TTaskInfo,
} from 'src/shared/types'

function pollOptimizeRoutResult(
  clientId: string,
  taskInfo: TTaskInfo,
  country?: string,
  makeUrl: MakeUrlApi = cargoApiURL,
): Promise<OptimizeRouteResultResponse> {
  return delay(DELAY_TIMEOUT_MS)
    .then(() => fetchOptimizeRouteResult(clientId, taskInfo, country, makeUrl))
    .then(result => {
      if (result.info.status === 'completed') {
        return result
      }

      return pollOptimizeRoutResult(clientId, result.info, country, makeUrl)
    })
}

function fetchOptimizeRouteResult(
  clientId: string,
  body: OptimizeRouteResultRequest,
  country?: string,
  makeUrl: MakeUrlApi = cargoApiURL,
): Promise<OptimizeRouteResultResponse> {
  return fetch({
    method: 'POST',
    url: addQuery(makeUrl('cargo-claims/v2/optimize-route/result'), {country}),
    headers: {
      'X-B2B-Client-ID': clientId,
    },
    body,
  })
}

export function fetchOptimizedRoute(
  clientId: string,
  body: OptimizeRouteStartRequest,
  country?: string,
  makeUrl: MakeUrlApi = cargoApiURL,
): Promise<OptimizeRouteResultResponse> {
  return fetch<OptimizeRouteStartRequest, TTaskInfo, TTaskInfo>({
    method: 'POST',
    headers: {
      'X-B2B-Client-ID': clientId,
    },
    url: addQuery(makeUrl('cargo-claims/v2/optimize-route/start'), {country}),
    body,
  }).then(result => pollOptimizeRoutResult(clientId, result, country, makeUrl))
}
